// extracted by mini-css-extract-plugin
module.exports = {"tableWithPagination":"TableWithPagination_tableWithPagination__1L53I"};